<p-toast></p-toast>
<div class="mi-challan-container" *ngIf="!(showFarmerShareChallan || showSanctionLetter || showFullPaymentChallan)">
    <p-card styleClass="p-card-shadow">
        <!-- <div class="card flex-wrap justify-content-between"> -->
        <!-- <div class="card flex-wrap justify-content-between"> -->
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-6">
                <h4 class="mt-3 ">{{'MI_CHALLAN'| translate}}</h4>
            </div>


            <div class="field col-12 md:col-6 grid">
                <!-- <div class="flex justify-content-center"> -->
                <label class="mx-4" htmlFor="appId"><b>{{'SELECT_APP_ID'| translate}}</b></label>
                <!-- </div> -->
                <!-- <div class="flex justify-content-center mt-3"> -->
                <p-dropdown [options]="famerAppDetailsforDropDown" [(ngModel)]="selectedFarmerDeatils"
                    optionLabel="appIdToDisplay" (onChange)="onSelectAppId()"
                    placeholder="{{'SELECT_APP_ID'| translate}}" [style]="{'width':'20vw'}"></p-dropdown>
                <!-- </div> -->
            </div>
        </div>


        <!-- </div> -->




        <!-- <div class="card mt-2">
            <div class="field ">
                <div class="flex justify-content-center">
                    <label htmlFor="appId"><b>Select Application Id</b></label>
                </div>
                <div class="flex justify-content-center mt-3">
                    <p-dropdown [options]="farmerAppDetails" [(ngModel)]="selectedFarmerDeatils" (onChange)="onSelectAppId()"
                        placeholder="Select an Application Id" optionLabel="appID" ></p-dropdown>
                </div>
            </div>
        </div> -->

        <div class="card mt-2" *ngIf="selectedFarmerDeatils != null">
            <div class="flex justify-content-around flex-wrap card-container blue-container">

                <!-- <button pButton type="button" label="{{'SANCTION_LETTER'| translate}}"
                    class="p-button-raised p-button-rounded p-button-info p-button-lg"
                    (click)="onSanctionLetterClick()"></button> -->

                <button pButton type="button" label="{{'FARMER_SHARE'| translate}}"
                    class="p-button-raised p-button-rounded p-button-info p-button-lg" (click)="onFarmerShareClick()"
                    [disabled]="selectedFarmerDeatils?.ChallanStatus =='FullPayment' "></button>

                <button pButton type="button" label="{{'FULL_PAYMENT'| translate}}"
                    class="p-button-raised p-button-rounded p-button-info p-button-lg" (click)="onFullPaymentClick()"
                    [disabled]="selectedFarmerDeatils?.ChallanStatus =='FarmerShare'"></button>
            </div>
            <!-- <div class="flex justify-content-around mt-5">
                <button pButton pRipple type="submit" label="Submit" class="p-button-success mr-2 mb-2"></button>
            </div> -->
        </div>

    </p-card>
</div>

<div class="card" *ngIf="showFarmerShareChallan || showSanctionLetter || showFullPaymentChallan">
    <app-farmer-share *ngIf="showFarmerShareChallan" [appId]="selectedAppId.AppId" 
        [progId]="selectedAppId.ProgID" (closeFarmerShareChallan)="showFarmerShareChallan = false">
    </app-farmer-share>
    <app-sanction-letter *ngIf="showSanctionLetter" [appId]="selectedAppId.AppId"
        [progId]="selectedAppId.ProgID" (closeSanctionLetter)="showSanctionLetter = false">
    </app-sanction-letter>
    <app-full-payment *ngIf="showFullPaymentChallan" [appId]="selectedAppId.AppId"
        [progId]="selectedAppId.ProgID" (closeFullPaymentChallan)="showFullPaymentChallan = false">
    </app-full-payment>
</div>